import firestore from '@paperstac/firebase/lib/firestore';
export var auditAccountsRef = function auditAccountsRef() {
  return firestore.collection('auditAccounts');
};
export var auditAccountByIdRef = function auditAccountByIdRef(auditAccountId) {
  return auditAccountId ? auditAccountsRef().doc(auditAccountId) : null;
};